export const portfolioSettingDrawer = {
    xSelect1: 'スコア（技術の進展度）',
    ySelect1: '市場期待値',
    company: {
        bubbleSelect1: 'スコア',
        bubbleSelect2: '特許出願数',
        bubbleSelect3: '被引用数（平均値）',
        bubbleSelect4: '重要特許数',
        bubbleSelect5: '重要特許率'
    },
    country: {
        bubbleSelect1: 'スコア（技術競争力）',
        bubbleSelect2: 'スコア（平均値）',
        bubbleSelect3: '特許出願数',
        bubbleSelect4: '被引用数（合計）',
        bubbleSelect5: '被引用数平均（特許ベース）',
        bubbleSelect6: '被引用数平均（企業ベース）',
        bubbleSelect7: '被引用数（上位N平均）',
        bubbleSelect8: '重要特許数',
        bubbleSelect9: '重要特許率'
    },
    setting: '設定',
    size: 'バブルの大きさ',
    bubbleScale: 'バブルサイズ強調度',
    bubbleSizeLimit: 'バブルサイズ上限',
    xLabel: 'X軸',
    yLabel: 'Y軸',
    zoomSlider: 'ズームスライダー',
    labelFixMode: 'ラベル固定',
    nonDisplay: '表示しない',
    labelClusterId: 'クラスタID',
    labelClusterName: 'クラスタ名',
    labelBubbleSize: 'バブルサイズ',
    initButton: '設定の初期化'
}
